<template>
  <v-container fluid grid-list-xl style="padding: 20px">
    <v-layout row wrap>
      <v-flex xs12 style="padding: 0 12px 10px">
        <v-card flat class="border-container">
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md3 lg4 xl4>
                <v-text-field
                  label="Buscar"
                  class="border-container"
                  prepend-inner-icon="search"
                  clearable
                  solo
                  flat
                  hide-details
                  v-model="filters.search"
                />
              </v-flex>
              <v-flex xs12 sm12 md2 lg2 xl2>
                <v-layout row>
                  <v-flex pr-1>
                    <div class="icon-select border-container">
                      <v-icon color="primary" medium>person</v-icon>
                    </div>
                  </v-flex>
                  <v-flex pl-1>
                    <v-select
                      class="border-container"
                      :items="types"
                      item-text="text"
                      v-model="filters.schedule_type"
                      label="Tiempos"
                      flat
                      solo
                      hide-details
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md2 lg2 xl2>
                <v-layout>
                  <v-flex pr-1>
                    <div class="icon-select border-container">
                      <v-icon color="primary" medium>schedule</v-icon>
                    </div>
                  </v-flex>
                  <v-flex pl-1>
                    <v-select
                      class="border-container"
                      :items="assistance"
                      item-text="text"
                      v-model="filters.attendance_type"
                      label="Asistencia"
                      solo
                      flat
                      hide-details
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
              <!-- AQUI INICIA EL DE ROL -->
              <v-flex xs12 sm12 md2 lg2 xl2>
                <v-layout row>
                  <v-flex pr-1>
                    <div class="icon-select border-container">
                      <v-icon color="primary" medium>group </v-icon>
                    </div>
                  </v-flex>
                  <v-flex pl-1>
                    <v-select
                      multiple
                      class="border-container"
                      :items="roles"
                      item-text="name"
                      v-model="filters.roleIds"
                      item-value="id"
                      flat
                      solo
                      hide-details
                    >
                      <template v-slot:label>
                        <span style="color: rgba(0, 0, 0, 0.87)">Rol</span>
                      </template>
                    </v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
              <!-- AQUI FINALIZA EL DE ROL  -->
              <v-flex
                md3
                sm2
                lg2
                xl2
                style="display: flex; justify-content: end"
              >
                <v-btn color="primary" @click="filterClear" v-show="showFilter">
                  <v-icon left>close</v-icon>Limpiar filtros
                </v-btn>
              </v-flex>
              <v-flex sm12 md8 lg6>
                <div class="border-container px-3">
                  <v-layout row wrap align-center>
                    <v-flex xs5 sm3 pr-0>Fecha de inicio</v-flex>
                    <v-flex xs7 sm3 pl-0 ml>
                      <v-menu
                        v-model="startDateMenu"
                        :close-on-content-click="true"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template late v-slot:activator="{ on }">
                          <v-text-field
                            id="first-small"
                            :value="momentFormatFirst"
                            label="Fecha de inicio"
                            prepend-icon="event"
                            readonly
                            solo
                            flat
                            hide-details
                            v-on="on"
                            class="padded"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          header-color="primary"
                          color="secondary"
                          locale="es-419"
                          v-model="filters.from"
                          scrollable
                          :min="firstDate"
                          :max="today"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex xs5 sm3 pr-0> Fecha de término</v-flex>
                    <v-flex xs7 sm3 pl-0>
                      <v-menu
                        v-model="endDateMenu"
                        :close-on-content-click="true"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="momentFormatLast"
                            id="last-small"
                            label="Fecha de término"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                            solo
                            flat
                            hide-details
                            class="padded"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          header-color="primary"
                          color="secondary"
                          locale="es-419"
                          v-model="filters.to"
                          scrollable
                          :min="filters.from"
                          :max="today"
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
              <v-flex
                class="box-circle-counter"
                v-for="attendanceCount in AttendanceCountListData"
              >
                <p>
                  {{ attendanceCountOptions[attendanceCount.type].text }}
                </p>
                <v-img
                  :style="{
                    backgroundColor:
                      attendanceCountOptions[attendanceCount.type].rgb,
                    borderRadius: '50%',
                  }"
                  max-height="50"
                  max-width="50"
                >
                  <p style="margin-top: 15px; color: white">
                    {{ attendanceCount.count }}
                  </p>
                </v-img>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 style="padding: 0 12px 10px">
        <v-card flat class="border-container">
          <v-card-text class="px-0 py-0">
            <v-data-table
              :rows-per-page-items="[25, 50, 100]"
              rows-per-page-text="Registros por página"
              :headers="headers"
              :items="items"
              :pagination.sync="pagination"
              :total-items="totalItems"
              :loading="loading"
              no-results-text="No se encontraron coincidencias"
              no-data-text="No hay registros"
              must-sort
            >
              <!-- <template v-slot:headers="props">
                <tr style="background-color: #dddddd">
                  <th v-for="header in props.headers" :key="header.text">
                    {{ header.text }}
                  </th>
                </tr>
              </template> -->
              <template v-slot:headers="props">
                <tr>
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="header.sortable ? 'sortable_pick' : ''"
                    @click="header.sortable ? changeSort(header.value) : null"
                    :style="header.style ? header.style : 'width: 150px'"
                  >
                    {{ header.text }}
                    <SortTableArrow
                      :hide="header.sortable === false"
                      :is-active="header.value === pagination.sortBy"
                      :is-upward="pagination.descending"
                    />
                  </th>
                </tr>
              </template>
              <v-progress-linear
                v-slot:progress
                color="primary"
                indeterminate
              ></v-progress-linear>

              <template v-slot:items="props">
                <tr classs="col_w">
                  <td>
                    {{ props.item.firstName }}
                  </td>
                  <td>
                    {{ props.item.lastName }}
                  </td>
                  <td>
                    {{ props.item.scheduleStartTime }}
                  </td>
                  <td>
                    {{ props.item.scheduleEndTime }}
                  </td>
                  <td>
                    {{ props.item.createdAt | formatDateA }}
                  </td>
                  <td>
                    {{ epochTimeParseToUi(props.item.dateIn) }}
                  </td>
                  <td>
                    {{ epochTimeParseToUi(props.item.dateOut) }}
                  </td>
                  <td>
                    <div class="d-flex alig-center">
                      <v-chip
                        v-if="props.item.attendanceType == 'LATE'"
                        color="#ffe490"
                        style="color: #bc8d5f"
                      >
                        <strong>Retardo</strong>
                      </v-chip>
                      <v-chip
                        v-if="props.item.attendanceType == 'ON_TIME'"
                        color="#8fe5c0"
                        style="color: #155d45"
                      >
                        <strong>Puntual</strong>
                      </v-chip>
                      <v-chip
                        v-if="props.item.attendanceType == 'ABSENCE'"
                        color="#fbdfde"
                        style="color: #b91b19"
                      >
                        <strong>Falta</strong>
                      </v-chip>
                      <button
                        @click="changeAttendance(props.item)"
                        :class="permitsEditAttendance ? '' : 'disabled'"
                      >
                        <img
                          :src="require('@/assets/icons/pencil_alt.svg')"
                          alt=""
                          height="20px"
                          style="
                            margin-top: 5px;
                            filter: brightness(0) invert(0);
                          "
                        />
                      </button>
                    </div>
                  </td>
                  <td>
                    {{ props.item.role }}
                  </td>
                  <td style="width: 300px; min-width: 300px">
                    <div
                      v-if="props.item.notes !== undefined"
                      style="display: grid; grid-template-columns: 200px 50px"
                    >
                      <div
                        class=""
                        style="
                          overflow: hidden;
                          text-overflow: ellipsis;
                          display: -webkit-box;
                          -webkit-line-clamp: 3;
                          line-clamp: 3;
                          -webkit-box-orient: vertical;
                        "
                      >
                        <v-tooltip top lazy max-width="300">
                          <template v-slot:activator="{ on }">
                            <div v-on="on">{{ props.item.notes }}</div>
                          </template>
                          <span>{{ props.item.notes }}</span>
                        </v-tooltip>
                      </div>
                      <div class="d-flex justify-end align-center">
                        <v-icon
                          size="19"
                          color="black"
                          @click="editNote(props.item)"
                        >
                          edit
                        </v-icon>
                        <v-icon
                          size="19"
                          color="black"
                          @click="deleteNote(props.item)"
                        >
                          delete
                        </v-icon>
                      </div>
                    </div>
                    <div v-else>
                      <span class="font-weight-medium">Agregar nota</span>
                      <br />
                      <v-btn
                        flat
                        icon
                        class="ma-0 primary white--text"
                        style="width: 20px; height: 20px"
                        @click="addNote(props.item)"
                      >
                        <v-icon size="15">add</v-icon>
                      </v-btn>
                    </div>
                  </td>
                </tr>
              </template>
              <template v-slot:no-data>
                <div
                  v-if="
                    (totalItems === 0 || totalItems === undefined) && showFilter
                  "
                >
                  No hay registros para filtrar
                </div>
                <div v-else>
                  No hay registros de asistencia, ya que no cuentas con horario
                  de entrada configurado para los colaboradores
                  <button @click="configCollabsShedule" style="color: #ef565c">
                    <u> Configurar horarios </u>
                  </button>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <ModalNote
      v-model="note.show"
      :ok-text="note.okText"
      :text="note.item.notes"
      :id="note.item.id"
      :is-edit="note.isEdit"
      @changeNote="onChangeNote"
      edit-note-ep="checker/editNote"
      add-note-ep="checker/addNote"
    />
    <EditAttendance
      v-model="modalAttendance.show"
      :student="modalAttendance.student"
      @updateAttendance="onUpdateAttendance"
    >
    </EditAttendance>
    <success v-model="modals.showSuccess" :text="modals.successText"></success>
    <error v-model="modals.showError" :text="modals.errorText"></error>
    <Loading v-model="modals.showLoading" text="Cargando..." />
    <ConfirmDelete
      :show="modals.showDelete"
      title="¿Estas seguro que deseas eliminar la nota del registro?"
      description="Una vez eliminada la nota, ya no se mostrará en el registro"
      cancel-text="No, Cancelar"
      ok-text="Si, eliminar"
      @change="onConfirmDelete"
    />
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { _isSomeDifferent } from '../../../utils/genericUtils.js'
import error from '../../Dialogs/Error.vue'
import Loading from '../../Dialogs/Loading.vue'
import ModalNote from '../../Dialogs/ModalNote.vue'
import success from '../../Dialogs/Success.vue'
import ConfirmDelete from '../../Dialogs/confirm_new_ui.vue'
import SortTableArrow from '../../Tools/SortTableArrow.vue'
import EditAttendance from './ModalUpdateStatus.vue'
import { Student } from './utils.js'

const initialValues = {
  from: moment().format('YYYY-MM-DD'),
  to: moment().format('YYYY-MM-DD'),
}
export default {
  components: {
    EditAttendance,
    success,
    error,
    SortTableArrow,
    ModalNote,
    ConfirmDelete,
    Loading,
  },
  data() {
    return {
      noRecord: 'Sin registro',
      attendanceCountOptions: {
        ON_TIME: { text: 'Puntual', rgb: '#4b8c93' },
        LATE: { text: 'Retardo', rgb: '#fcb243' },
        ABSENCE: { text: 'Falta', rgb: '#ea5d60' },
      },
      AttendanceCountListData: [],
      permitsEditAttendance: false,
      toast: {
        success: false,
        failed: false,
        alert: false,
        message: '',
      },
      modals: {
        showError: false,
        errorText: '',
        showSuccess: false,
        successText: '',
        showDelete: false,
        showLoading: false,
      },
      modalAttendance: {
        show: false,
        /**@type {Student} */
        student: null,
      },
      types: [
        { text: 'Todos', value: '' },
        { text: 'Tiempo completo', value: 'FULL_TIME' },
        { text: 'Por horas', value: 'HOURS_BY_DAY' },
      ],
      roles: null,
      assistance: [
        { text: 'Todos', value: '' },
        { text: 'Puntual', value: 'ON_TIME' },
        { text: 'Retardos', value: 'LATE' },
        { text: 'Falta', value: 'ABSENCE' },
      ],
      period: ['Diario', 'Semanal', 'Mensual', 'Semestral', 'Anual'],
      filters: {
        from: moment().format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
        schedule_type: '',
        attendance_type: '',
        period: '',
        search: '',
        roleIds: '',
      },
      showFilter: false,
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 25,
        sortBy: 'NAME',
      },
      startDateMenu: false,
      endDateMenu: false,
      today: moment().format('YYYY-MM-DD'),
      firstDate: new Date(
        new Date().setDate(new Date().getDate() - 30)
      ).toLocaleDateString('sv-SE'),
      totalItems: 0,
      items: [],
      headers: [
        {
          text: 'Nombre',
          value: 'NAME',
          sortable: true,
          align: 'center',
        },
        {
          text: 'Apellidos',
          value: 'LAST_NAME',
          sortable: true,
          align: 'center',
        },
        {
          text: 'Horario de entrada',
          value: 'scheduleStartTime',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Horario de salida',
          value: 'scheduleEndTime',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Fecha',
          value: 'dateIn',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Hora de ingreso',
          value: 'TIME_IN',
          sortable: true,
          align: 'center',
        },
        {
          text: 'Hora de salida',
          value: 'TIME_OUT',
          sortable: true,
          align: 'center',
        },
        {
          text: 'Asistencia',
          value: 'ATTENDANCE_TYPE',
          sortable: true,
          align: 'center',
        },
        {
          text: 'Rol',
          value: 'ROLE',
          sortable: true,
          align: 'center',
        },
        {
          text: 'Notas',
          value: 'NOTES',
          sortable: false,
          align: 'center',
          style: 'width: 300px',
        },
      ],
      loading: true,
      id_schedule_attendance: '',
      note: {
        show: false,
        item: new Student({ notes: '' }),
        okText: '',
        isEdit: false,
      },
    }
  },
  mounted() {
    this._setPermission()
    this.fetchEntries(this.filters, this.pagination, true)
    this.getAttendanceByRoles()
  },
  watch: {
    pagination: {
      handler() {
        this.fetchEntries(this.filters, this.pagination)
      },
      deep: true,
    },
    filters: {
      handler() {
        this.fetchEntries(this.filters, this.pagination)
        this.$emit('updateFilters', { ...this.filters })
        this.getAttendanceByRoles()
      },
      deep: true,
    },
    getUser() {
      this._setPermission()
    },
  },
  methods: {
    addNote(note) {
      this.note.isEdit = false
      this.note.okText = 'Agregar'
      this.note.item = note
      this.note.show = true
    },
    editNote(note) {
      this.note.isEdit = true
      this.note.okText = 'Guardar'
      this.note.item = note
      this.note.show = true
    },
    async onChangeNote(e) {
      if (e === undefined) return

      this.note.item.notes = e
    },
    deleteNote(note) {
      this.note.item = note
      this.modals.showDelete = true
    },
    async onConfirmDelete(e) {
      this.modals.showDelete = false
      if (e === false) return

      this.modals.showLoading = true
      try {
        await this.$store.dispatch('checker/deleteNote', this.note.item.id)

        this.modals.successText = 'Éxito al eliminar la nota'
        this.modals.showSuccess = true
      } catch (error) {
        console.log(error)
        this.modals.errorText = 'Ocurrió un error al eliminar la nota'
        this.modals.showError = true
      } finally {
        this.modals.showLoading = false
        this.fetchEntries(this.filters, this.pagination)
      }
    },
    configCollabsShedule() {
      this.$emit('configCollabsShedule', true)
    },
    epochTimeParseToUi(value = null) {
      if (value === null) return this.noRecord

      return moment(new Date(value))
        .tz(this.getBrandTZ.timezone)
        .format('HH:mm:ss')
    },
    _setPermission() {
      if (this.getUser.webRole === undefined) return
      const isAdmin = this.getUser.webRole.hierachy === 0
      const allowEditAttendance = this.getUser.webRole.catalogs.filter(
        (e) => e.name === 'UPDATEATTENDANCE_SCHEDULE_COLLABORATOR'
      )

      if (allowEditAttendance.length === 0) return
      this.permitsEditAttendance = isAdmin || allowEditAttendance.length === 1
    },
    async onUpdateAttendance(value) {
      if (value === null) return

      if (value === this.modalAttendance.student.attendanceType) return

      const [dataMsg, error] = await this._updateAttendance(value)

      if (error !== null) {
        this.toast.showError = true
        this.modals.errorText = error
        return
      }

      this.modals.showSuccess = true
      this.modals.successText = dataMsg
      this.fetchEntries(this.filters, this.pagination)
    },
    async _updateAttendance(value) {
      /**
       * @typedef {{type: "ON_TIME"|"LATE, ON_TIME" | "ABSENCE"}} Type
       * @type {{id_schedule_attendance: number, body: Type}} data
       */
      const params = {
        idSchedule: this.modalAttendance.student.id,
        body: { type: value },
      }

      try {
        await this.$store.dispatch('checker/editStatusSchedule', params)
        return ['Actualizado exitosamente.', null]
      } catch (error) {
        console.error(error.response.status)
        if (error.response.status === 404) return [null, 'Valor no permitido.']
        if (error.response.status === 404)
          return [null, 'No se encontró el registro de horario proporcionado.']
        return [null, 'Ocurrió un error']
      }
    },

    changeAttendance(student) {
      if (this.permitsEditAttendance === false) return

      this.modalAttendance.show = true
      this.modalAttendance.student = structuredClone(student)
    },
    filterClear() {
      this.filters = {
        from: moment().format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
        schedule_type: '',
        attendance_type: '',
        period: '',
        search: '',
        roleIds: '',
      }
      this.pagination.page = 1
      this.pagination.descending = false
      this.pagination.rowsPerPage = 25
      this.pagination.sortBy = 'NAME'
      this.showFilter = false
      this.fetchEntries(this.filters, this.pagination)
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
      this.fetchEntries(this.filters, this.pagination)
    },
    fetchEntries(filters, pagination, isInitialStateParams = false) {
      this.loading = true
      this.totalItems = 0
      const newFilters = {}
      for (const property in filters) {
        const value = filters[property]
        if (value) {
          newFilters[property] = value
        }
      }
      const params = {
        ...newFilters,
        orderBy: this.pagination.sortBy,
        orderType: this.pagination.descending ? 'DESC' : 'ASC',
        size: pagination.rowsPerPage,
        offset: (pagination.page - 1) * pagination.rowsPerPage,
      }
      if (this.filters.roleIds.length === 0) {
        delete params.roleIds
      }

      if (isInitialStateParams === true) {
        const tempObj = structuredClone(params)
        const tempParams = Object.keys(tempObj)
          .filter((e) => tempObj[e] !== undefined)
          .map((e) => `${e}_${tempObj[e]}`)
        this.initialStateParams = tempParams
        return
      }

      const tempObj = structuredClone(params)
      const tempParams = Object.keys(params)
        .filter((e) => tempObj[e] !== undefined)
        .map((e) => `${e}_${tempObj[e]}`)

      this.showFilter = _isSomeDifferent(this.initialStateParams, tempParams)
      this.$store
        .dispatch('checker/listAttendance', params)
        .then((res) => {
          this.items = res.data
          this.totalItems = res.total
        })
        .finally(() => (this.loading = false))
      this._getAttendanceCount(params)
    },

    getAttendanceByRoles() {
      const query = {
        from: this.filters.from,
        to: this.filters.to,
      }
      this.$store
        .dispatch('checker/getRolesAttendance', query)
        .then((res) => {
          this.roles = res.data
        })
        .finally(() => (this.loading = false))
    },
    async _getAttendanceCount(params) {
      try {
        const { data } = await this.$store.dispatch(
          'checker/getRolesAttendanceCount',
          params
        )
        const sortedAttendanceCountList = data.sort((a, b) => {
          if (a.type < b.type) {
            return 1
          }
          if (a.type > b.type) {
            return -1
          }
          return 0
        })

        this.AttendanceCountListData = sortedAttendanceCountList
      } catch (error) {
        this.AttendanceCountListData = [
          new AttendanceCount({ type: 'ON_TIME' }),
          new AttendanceCount({ type: 'LATE' }),
          new AttendanceCount({ type: 'ABSENCE' }),
        ]
      }
    },
  },
  filters: {
    formatHour(dateInMs) {
      return moment(dateInMs).format('hh:mm a')
    },
  },
  computed: {
    momentFormatFirst() {
      if (this.filters.from != null) {
        return moment(this.filters.from).format('DD/MM/YYYY')
      }
      return ''
    },
    momentFormatLast() {
      if (this.filters.to != null) {
        return moment(this.filters.to).format('DD/MM/YYYY')
      }
      return ''
    },
    isInitialValues() {
      return (
        initialValues.from == this.filters.from &&
        initialValues.to == this.filters.to &&
        !this.filters.schedule_type &&
        !this.filters.attendance_type &&
        !this.filters.period &&
        !this.filters.search &&
        !this.filters.roleIds
      )
    },
    ...mapGetters(['getUser', 'getBrandTZ']),
  },
}
</script>

<style scoped>
.col_w {
  width: 150px;
}
.sortable_pick {
  cursor: pointer;
}
.box-circle-counter > div {
  margin-right: auto;
  margin-left: auto;
}
.box-circle-counter p {
  text-align: center;
  font-weight: 600;
}
.border-container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  overflow: hidden;
}
.rol {
  color: rgba(0, 0, 0, 0.87);
}
.icon-select {
  padding: 8px;
}
.disabled {
  opacity: 0.3;
  cursor: default;
}
::v-deep .v-input__prepend-outer {
  margin-right: -1px !important;
}
::v-deep .padded .v-input__slot {
  padding-left: 8px !important;
}

::v-deep .v-datatable.v-table > thead {
  display: table;
  width: 100%;
  table-layout: fixed;
}

table.v-table > thead tr {
  background-color: #dddddd;
  height: 40px;
}

::v-deep .v-datatable.v-table > tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
::v-deep .v-chip {
  display: flex;
  justify-content: center;
}

@media (max-width: 600px) {
  ::v-deep .v-datatable.v-table > thead {
    display: block;
  }
}
</style>
